import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useHistory, useParams } from "react-router-dom";
import { unwrapResult } from '@reduxjs/toolkit'
import { fetchVoidReason, saveVoidReason } from "../../../store/thunks/voidReasonsThunk";
import { getVoidReason, unloadVoidReasons } from "../../../store/slices/datasources/voidReasonsSliceDatasource";
import WithLoadingPage from "../commons/withLoadingPage";
import Flash from "../elements/flash";
import PageSubHeader from "../elements/pageSubHeader";

const VoidReasonForm = props => {
    
	const dispatch = useDispatch();
    const history = useHistory();
	const routeParams = useParams();
    const { id: voidReasonId } = routeParams;
	const voidReason = useSelector(getVoidReason(voidReasonId));
	const { setLoading } = props;
	const [request, setRequest] = React.useState({ id: null, category: "", reason: "" });
	const [error, setError] = React.useState({ category: null, reason: null });

    React.useEffect(() => {
        return () => {
            dispatch(unloadVoidReasons());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {		
        async function initialize() {
            setLoading(true);
            if (parseInt(voidReasonId)) {
                await dispatch(fetchVoidReason(getQueryFilter()));
            }
            setLoading(false);
        }
		
        initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch, voidReasonId]); 
	
	React.useEffect(() => {
		if (voidReason) {
			const mapViewToModel = {
				id: voidReason.id,
				category: voidReason.category,
				reason: voidReason.reason
			}

			setRequest(prev => { 
                return { 
                    ...prev, 
                    ...mapViewToModel 
                }
            });
		}
	}, [voidReason]);

    const getQueryFilter = () => {
        const queryFilter = {
            id: voidReasonId,
        };

        return {
            query: queryFilter
        };
    }

	const handleInputChange = element => {
		const { name, value } = element.target;
		setRequest({...request, [name]: value});
	}

	const handleFormSubmit = async event => {
		event.preventDefault();
		setLoading(true);
		await dispatch(saveVoidReason(request))
			.then(unwrapResult)
			.then(() => {
				setLoading(false);
				setError({ ...error, reason: null });
				history.push('/data/void-reasons');
			})
			.catch(exception => {
				setLoading(false);
				setError(exception.errors);
			});
	}

    return (
        <React.Fragment>
            <PageSubHeader title={`${voidReasonId === "add" ? "New" : "Edit"} Void Reason`} />
            <div className="mx-auto w-2/4">
                <Flash />
                <div className="classic card">
                    <div className="card-header bg-light-600">
                        <h3 className="card-title">Void Reason Form</h3>
                    </div>
                    <div className="card-body text-left">
                        <form className="w-full" onSubmit={handleFormSubmit}>
                            <div className="form-group">
                                <label className="form-label" htmlFor="category">Category</label>
                                <select id="category" name="category" className="form-control" value={request.category} onChange={handleInputChange}>
                                    <option value="">- Select -</option>
                                    <option value="Sales Order">Sales Order</option>
                                    <option value="Sales Order Detail">Sales Order Detail</option>
                                    <option value="Sales Invoice">Sales Invoice</option>
                                    <option value="Payment">Payment</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label className="form-label" htmlFor="reason">Reason</label>
                                <textarea id="reason" name="reason" type="text" className="form-control" value={request.reason} onChange={handleInputChange} rows="5" resize="none" />
                            </div>
                            <div className="form-group text-right">
                                <NavLink to="/data/void-reasons" className="btn btn-secondary mr-4">
                                    <i className="las la-undo" />
                                    Back
                                </NavLink>
                                <button className="btn btn-primary mr-4">
                                    <i className="las la-save" />
                                    Save
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
 
export default WithLoadingPage(VoidReasonForm);